import { v4 as uuid } from "uuid";
import { cpf, cnpj } from "cpf-cnpj-validator";

export const isDocumentValid = (document = "") => {
  if (!document.length) return false;

  if (document.length === 11) return cpf.isValid(document);
  if (document.length === 14) return cnpj.isValid(document);
};

export const mask = (v, r) => {
  if (!v) return;

  if (r === "mac") {
    //v.value = v.value.replace(/^[a-fA-F0-9]{2}(:[a-fA-F0-9]{2}){5}$/g, "");
    v.value = v.value.replace(/[^a-fA-F0-9]/g, "");

    if (v.value.length === 12)
      v.value = v.value.replace(
        /([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2}).*/g,
        "$1:$2:$3:$4:$5:$6",
      );
    else
      v.value = v.value.replace(
        /([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2}).*/g,
        "$1:$2:$3:$4:$5:$6:$7:$8",
      );

    return v.value;
  }

  if (r === "decimal") {
    //check negative values
    const i = /\+/.test(v.value) ? 1 : /\-/.test(v.value) ? -1 : 1;

    v.value = v.value.replace(/[^\d]/g, "");

    const t = Number(v.value) / 100;

    return (t * i).toFixed(2);
  }

  if (r === "moeda") {
    v.value = v.value.replace(/[^\d+]/g, "");
    let t = v.value;

    if (Number(t) < 10 || t == "")
      v.value = v.value.replace(/.*(\d+)/g, "0,0$1");
    else if (Number(t) < 100) v.value = v.value.replace(/.*(\d{2})/g, "0,$1");
    else if (t.length < 6)
      v.value = v.value.replace(/^0+/g, "").replace(/(\d+)(\d{2})/g, "$1,$2");
    else if (t.length < 9)
      v.value = v.value
        .replace(/^0+/g, "")
        .replace(/(\d+)(\d{3})(\d{2})/g, "$1.$2,$3");
    else if (t.length < 12)
      v.value = v.value
        .replace(/^0+/g, "")
        .replace(/(\d+)(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3,$4");
    else
      v.value = v.value
        .replace(/^0+/g, "")
        .replace(/(\d+)(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3.$4,$5");

    v.value = "R$ " + v.value;

    return v.value;
  }

  if (r === "cpfcnpj") {
    v.value = v.value.replace(/[^\d+]/g, "");
    if (v.value.length > 11) {
      v.value = v.value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/g,
        "$1.$2.$3/$4-$5",
      );
    } else {
      v.value = v.value.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2}).*/g,
        "$1.$2.$3-$4",
      );
    }

    return v.value;
  }

  if (r === "cpf") {
    v.value = v.value.replace(/[^0-9]/g, "");
    v.value = v.value.replace(/(\d{3})(\d{3})(\d{3})(\d{2}).*/g, "$1.$2.$3-$4");

    return v.value;
  }

  if (r === "cnpj") {
    v.value = v.value.replace(/[^0-9]/g, "");
    v.value = v.value.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/g,
      "$1.$2.$3/$4-$5",
    );

    return v.value;
  }

  if (r === "telefone" || r === "celular") {
    v.value = v.value.replace(/[^0-9]/g, "");
    v.value = v.value.replace(/(\d{2})(\d{4,5})(\d{4}).*/g, "($1) $2-$3");

    return v.value;
  }

  if (r === "cep") {
    v.value = v.value.replace(/[^0-9]/g, "");
    v.value = v.value.replace(/(\d{5})(\d{3}).*/g, "$1-$2");

    return v.value;
  }

  if (r === "data") {
    v.value = v.value.replace(/[^0-9]/g, "");
    v.value = v.value.replace(/(\d{2})(\d{2})(\d{4})/g, "$1/$2/$3");

    return v.value;
  }
};

export const moneyMask = (v) => {
  try {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(v);
  } catch (e) {
    return 0;
  }
};

export const parseDateISO = (d) => {
  try {
    let p = d.split("T")[0].split("-");
    return p[2] + "/" + p[1] + "/" + p[0];
  } catch (e) {
    return null;
  }
};

export const parseDate = (d) => {
  try {
    let p = new Date(d);
    const day = `${p.getDate()}`.padStart(2, "0");
    const month = `${p.getMonth() + 1}`.padStart(2, "0");
    const year = p.getFullYear();
    const hour = `${p.getHours()}`.padStart(2, "0");
    const minutes = `${p.getMinutes()}`.padStart(2, "0");

    return {
      default: `${year}-${month}-${day}`,
      date: `${day}/${month}/${year}`,
      time: `${hour}:${minutes}`,
      getFull: function () {
        return `${this.date} ${this.time}`;
      },
    };
  } catch (e) {
    return "---";
  }
};

export const isToday = (someDate) => {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
};

export function diff_hours(dt2, dt1) {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.floor(diff);
}

export const handleCopyDigits = (value) => {
  try {
    navigator.clipboard.writeText(value);
  } catch (e) {
    alert("Não foi possível copiar texto!");
  }
};

export const isEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export function sleep(delay = 0) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

export const generateUid = () => {
  return uuid();
};

export const handleOpenWhatsapp = (number, msg = "") => {
  try {
    let parseNumber = `+55${number}`;

    handleCopyDigits(decodeURI(msg));

    window.open(`https://wa.me/${parseNumber}?text=${msg}`, "web.whatsapp.com");
  } catch (e) {
    alert(e.message);
  }
};

export const unmaskMoney = (value) => {
  try {
    return Number(value.replace(/[^\d+]/g, "")) / 100;
  } catch (e) {
    return 0;
  }
};

export const lastDaysDate = (lastDays) => {
  // Obter a data atual
  const dataAtual = new Date();

  // Obter a data de ontem
  const lastDate = new Date();
  lastDate.setDate(dataAtual.getDate() - lastDays);

  return lastDate;
};

export const unmask = (v, r) => {
  if (r === "moeda") {
    try {
      return Number(
        v.replace(/[^\d+]/g, "").replace(/(\d+)(\d{2})$/g, "$1.$2"),
      );
    } catch (e) {}
  }

  return 0;
};

//obtem data atual com h horas de antecedencia
export function getMinHourTime(h = 1) {
  // Pega o horário atual
  const now = new Date();

  // Soma 1 hora
  now.setHours(now.getHours() + h);

  // Converte para formato compatível com datetime-local (YYYY-MM-DDTHH:MM)
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  const minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

  return minDateTime;
}

export function formatValue(valor) {
  const absValor = Math.abs(valor);
  let formatado;

  if (absValor >= 1_000_000_000) {
    formatado = (valor / 1_000_000_000).toFixed(1).replace(".", ",") + "B";
  } else if (absValor >= 1_000_000) {
    formatado = (valor / 1_000_000).toFixed(1).replace(".", ",") + "M";
  } else if (absValor >= 1_000) {
    formatado = (valor / 1_000).toFixed(1).replace(".", ",") + "K";
  } else {
    formatado = valor.toFixed(2).replace(".", ",");
  }

  return `R$ ~${formatado}`;
}
